/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from 'primereact/button';
import { FileQuestion } from 'lucide-react';

export const DocsNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{ height: '85%' }}
      className="flex flex-column align-items-center justify-content-center w-full text-center"
    >
      <div className="surface-ground border-round-xl  flex flex-column align-items-center border-1 surface-border max-w-3xl">
        <div
          className="flex align-items-center justify-content-center mb-4 border-circle bg-primary-100 text-primary"
          style={{ width: '80px', height: '80px' }}
        >
          <FileQuestion size={40} strokeWidth={1.5} />
        </div>

        <h1 className="text-900 font-bold text-4xl mb-2">404 - Page Not Found</h1>

        <p className="text-600 text-lg mb-5 max-w-2xl">
          We couldn't find the documentation page you were looking for. It might have been moved, deleted, or perhaps
          the URL is incorrect.
        </p>

        <div className="flex gap-3">
          <Button label="Go Back" icon="pi pi-arrow-left" className="p-button-outlined" onClick={() => navigate(-1)} />
          <Button label="Docs Home" icon="pi pi-home" onClick={() => navigate('/docs')} />
        </div>
      </div>
    </div>
  );
};
